import { render, staticRenderFns } from "./ResourceWorkList.vue?vue&type=template&id=53d4bcd5&scoped=true"
import script from "./ResourceWorkList.vue?vue&type=script&lang=js"
export * from "./ResourceWorkList.vue?vue&type=script&lang=js"
import style0 from "./ResourceWorkList.vue?vue&type=style&index=0&id=53d4bcd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4bcd5",
  null
  
)

export default component.exports